/* src/app/features/prestacao-informacoes/acompanhamento-processual/acompanhamento-processual-pesquisa.component.scss */
/*# sourceMappingURL=acompanhamento-processual-pesquisa.component.css.map */
